import { FC } from "react"
import clsx from "clsx"

interface PurpleToggleProps {
  checked: boolean
  onChange: () => void
  label?: string
  disabled?: boolean
}

export const PurpleToggle: FC<PurpleToggleProps> = ({ checked, onChange, label, disabled = false }) => {
  return (
    <div className="flex items-center gap-3">
      <label
        className={clsx("relative inline-flex items-center w-11 h-6", {
          "cursor-pointer": !disabled,
          "cursor-not-allowed": disabled
        })}
      >
        <input type="checkbox" className="sr-only peer" checked={checked} disabled={disabled} onChange={onChange} />
        <div
          className={clsx(
            "w-full h-full peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-purple-400 rounded-full transition-colors duration-300 ease-in-out",
            {
              "bg-[rgba(169,78,206,1)]": checked,
              "bg-[rgba(169,78,206,0.4)]": !checked,
              "opacity-50": disabled
            }
          )}
        />
        <div
          className={clsx("absolute top-0.5 left-0.5 w-5 h-5 rounded-full shadow-md transition-transform duration-300 ease-in-out", {
            "translate-x-5 bg-[#cccccc]": checked,
            "bg-[#9f90a7]": !checked
          })}
        />
      </label>
      {label && <span className="text-sm text-gray-700 dark:text-gray-300">{label}</span>}
    </div>
  )
}
